import React, { createContext, useContext } from "react"
import { useRecoilState } from "recoil"
import lodash from "lodash"

import { treeStateFamily } from "./state"

const TariffsContext = createContext({})

const useTariffs = propId => {
  const { id: contextId } = useContext(TariffsContext)

  const id = propId || contextId

  const [tree, setTree] = useRecoilState(treeStateFamily(id))

  const mergeTree = subtree => {
    setTree(currentTree => {
      // console.log("merge treeeee", { currentTree, subtree })
      const result = mergeDeep(lodash.cloneDeep(currentTree), subtree)

      // console.log("mergeTree", { currentTree, subtree, result })
      return result
    })
  }

  return { tree, setTree, mergeTree }
}

export default useTariffs

export const TarrifsContextProvider = props => (
  <TariffsContext.Provider {...props} />
)

// function mergeDeep(tree, subtree) {}

function mergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (lodash.isObject(target) && lodash.isObject(source)) {
    for (const key in source) {
      if (lodash.isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}
